// Métadonnées d'affichage de la visibilité d'une plongée (public / friends / club / private).
// Sert au petit badge sous le nom de l'organisateur (couleur de la pastille + clé i18n).
const META = {
    public: { color: "#2e9e5b" },
    friends: { color: "#b9770a" },
    club: { color: "#0077b6" },
    private: { color: "#c23a52" },
};

export function diveVisibilityMeta(visibility) {
    const key = META[visibility] ? visibility : "public";
    return { key, color: META[key].color };
}
